import { useEffect, useState } from "react"
import { usePresignedDownloadUrl } from "./downloadFIle.hook"
import { useMessage } from "hooks/message.hook"
import { useFileModalStore } from "store/modal.store"
import { removeApiVersion } from "helpers/utils.helper"

export const useDocumentPreview = () => {
	const [previewLink, setPreviewLink] = useState<string>()
	const [previewData, setPreviewData] = useState<string | null>(null)
	const [reloadTrigger, setReloadTrigger] = useState(false)

	const { error: errorMessage } = useMessage()
	const { refetch: refetchPreview } = usePresignedDownloadUrl(previewData)
	const { triggerFileModal } = useFileModalStore()

	// Toggle the reloadTrigger state to force re-fetching the presigned URL and reloading the document
	const forceReload = () => {
		setReloadTrigger(!reloadTrigger)
	}

	// Effect for fetching presigned URL and setting it for preview
	useEffect(() => {
		if (previewData) {
			refetchPreview()
				.then((result) => {
					if (result.isSuccess && result.data) {
						const downloadUrl = result.data.download_url
						setPreviewLink(downloadUrl)
						triggerFileModal()
					}
				})
				.catch(() => {
					errorMessage("Something went wrong, please try again later")
				})
		}
	}, [previewData, refetchPreview, triggerFileModal, errorMessage, reloadTrigger])

	// Handles opening file preview
	const previewHandle = (downloadLink: string) => {
		const cleanLink = removeApiVersion(downloadLink)
		setPreviewData(cleanLink)
		forceReload()
	}

	return { previewLink, previewHandle }
}
